<template>
  <div>
    <BaseSelect :items="filteredItems" @input="setActiveItem" :class="`${el}__dropdown`" expand />

    <Col auto class="u-margin__vertical--3">
      <ToggleSwitch
        inactiveLabel="gesetzlich"
        activeLabel="privat"
        @click="setPrivate"
        :checked="isPrivate"
      />
    </Col>

    <div v-if="activeItem && showAddress" :class="`${el}__contact`">
      <div :class="`${el}__contactItem ${el}__contactItemAddress`">
        <Headline size="xs" noMargin>Anschrift</Headline>
        <div :class="`${el}__contactItemContent`">
          <strong>{{ activeItem.label }}</strong>
          <br />
          {{ activeItem.street }}
          <br />
          <Copy v-if="activeItem.street === '' || activeItem.street === null">
            {{ $t('healthInsurances.noData') }}
          </Copy>
          {{ activeItem.city }}
        </div>
      </div>
      <div v-if="activeItem.tel" :class="`${el}__contactItem`">
        <Headline size="xs" noMargin>Telefon</Headline>
        <div :class="`${el}__contactItemContent`">
          <a :href="`tel:${activeItem.tel}`" :class="`${el}__contactLink`">
            <Icon name="phone-line" :class="`${el}__contactLinkIcon`" />
            {{ activeItem.tel }}
          </a>
        </div>
      </div>
      <div v-if="activeItem.email" :class="`${el}__contactItem`">
        <Headline size="xs" noMargin>E-Mail</Headline>
        <div :class="`${el}__contactItemContent`">
          <a :href="`mailto:${activeItem.email}`" :class="`${el}__contactLink`">
            <Icon name="mail-line" :class="`${el}__contactLinkIcon`" />
            {{ activeItem.email }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import BaseSelect from '@/objects/Forms/BaseSelect';
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy/';
import Col from '@/components/Grid/Col/';

import { mapFieldsAuth } from '@/store/mapFields';
import { ROUTE_API_GET_INSURANCES } from '@/constants/apiRoutes';
import Vue from 'vue';
import ToggleSwitch from '@/objects/ToggleSwitch/ToggleSwitch';

export default {
  name: 'HealthInsurances',
  components: {
    Col,
    ToggleSwitch,
    Copy,
    Headline,
    Icon,
    BaseSelect,
  },
  props: {
    activeInsurance: {
      type: Number,
      required: false,
      default: 0,
    },
    showAddress: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
  },

  data() {
    return {
      items: [],
      activeItem: null,
      isPrivate: false,
      filteredItems: [],
      el: 'c-healthInsurances',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  created() {
    this.getInsurances();
  },
  methods: {
    setActiveItem(value) {
      this.filteredItems.map((insurance) => {
        if (parseInt(insurance.value) === parseInt(value)) {
          this.activeItem = insurance;
        }
      });

      this.$emit('insuranceSet', this.activeItem);
    },
    getInsurances() {
      Vue.axios
        .get(ROUTE_API_GET_INSURANCES)
        .then((response) => {
          const healthInsurances = response.data.insurances;
          const items = [];
          healthInsurances.map((hi) => {
            items.push({
              value: hi.id,
              label: hi.name,
              selected: this.activeInsurance ? this.activeInsurance === hi.id : false,
              street: hi.street,
              city: hi.city,
              tel: hi.tel,
              fax: hi.fax,
              email: hi.email,
              isPrivate: hi.private === 0 ? false : true,
              key: hi.care_fund_key,
            });

            if (this.activeInsurance === hi.id) {
              this.isPrivate = hi.private === 0 ? false : true;
            }
          });

          this.items = items;

          this.filterItems();

          if (this.activeInsurance) {
            this.setActiveItem(this.activeInsurance);
          }
        })
        .catch(() => {
          this.statusCode = 401;
        });
    },

    setPrivate() {
      this.isPrivate = !this.isPrivate;
      this.filterItems();
    },

    filterItems() {
      this.filteredItems = this.items.filter((item) => item.isPrivate === this.isPrivate);
      this.filteredItems.unshift({
        value: 0,
        key: null,
        label: 'keine Angabe',
        selected: this.activeInsurance ? this.activeInsurance === 0 : false,
      });
    },
  },
};
</script>
